import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, IconButton, Tooltip, Typography, useTheme, alpha } from '@mui/material'

const StatCard = ({
  label,
  value,
  hint,
  highlight,
}: {
  label: string
  value: number | string
  hint?: string
  highlight?: boolean
}) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 1.5,
        px: 1.5,
        borderRadius: 1.5,
        bgcolor: highlight
          ? alpha(theme.palette.text.highlight, isDark ? 0.08 : 0.06)
          : alpha(theme.palette.text.primary, isDark ? 0.03 : 0.02),
        border: '1px solid',
        borderColor: highlight ? alpha(theme.palette.text.highlight, 0.2) : 'divider',
        transition: 'all 0.15s ease',
        '&:hover': {
          borderColor: highlight ? alpha(theme.palette.text.highlight, 0.35) : 'text.secondary',
        },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.25,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: 10,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: 'text.secondary',
          }}
        >
          {label}
        </Typography>
        {hint && (
          <Tooltip title={hint} placement="top">
            <InfoOutlinedIcon sx={{ fontSize: 12, color: 'text.disabled', cursor: 'help' }} />
          </Tooltip>
        )}
      </Box>
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: highlight ? 'primary.main' : 'text.primary',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value ?? '—'}
      </Typography>
    </Box>
  )
}

export default StatCard
